let AUTH_TOKEN_KEY = "petitnature-accessToken";
let USER_KEY = "petitnature-loggedUsername";

export default {
  getToken() {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  },
  setToken(token) {
    localStorage.setItem(AUTH_TOKEN_KEY, token);
  },
  setUser(user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  },
  getUser() {
    return JSON.parse(localStorage.getItem(USER_KEY));
  },
  deleteToken() {
    localStorage.removeItem(AUTH_TOKEN_KEY);
  },
  deleteUser() {
    localStorage.removeItem(USER_KEY);
  }
};
